import React, { useState, useMemo } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import _ from 'lodash'
import { useTheme } from '@mui/material'
import ScrollFixedTopContainer from 'src/components/ScrollFixedTopContainer'
import Search from '../../../../components/Search'
import { checkOnFilter } from '../../../../components/Filter/events'
import FilterButton from '../../components/FilterButton'
import { BackButton } from '../../components'
import FilterDrawer from '../Filter/FilterDrawer'
import { fetchLearningPathList } from '../events'
import { StyledListHeader, StyledRightFlex } from './Styled'
import { handleChangeSearch } from './events'

const ListHeader = () => {
  const theme = useTheme()
  const dispatch = useDispatch()
  const history = useHistory()
  const { filterBody, name } = useSelector(
    (state) => ({
      filterBody: _.get(state.eLearningLearningPathList, 'filterBody', null),
      name: _.get(state.eLearningLearningPathList.filterBody, 'name', []),
    }),
    shallowEqual
  )
  const [isOpen, setOpen] = useState(false)
  const isOnFilter = useMemo(() => checkOnFilter(filterBody), [filterBody])

  return (
    <ScrollFixedTopContainer
      sx={{ backgroundColor: theme.palette?.background?.blue }}
    >
      <StyledListHeader>
        <BackButton onClick={() => history.push('/')} />

        <StyledRightFlex>
          <Search
            boxSx={{ width: 302 }}
            placeholder="ค้นหาชื่อเส้นทางการเรียนรู้"
            text={name}
            setText={(e) => dispatch(handleChangeSearch(e))}
            handleSearch={() => dispatch(fetchLearningPathList(filterBody))}
          />
          <FilterButton isOnFilter={isOnFilter} onClick={() => setOpen(true)} />
        </StyledRightFlex>
      </StyledListHeader>
      <FilterDrawer isOpen={isOpen} setOpen={setOpen} />
    </ScrollFixedTopContainer>
  )
}
export default ListHeader
